import React from "react";
import {AppBar, IconButton, Stack, Toolbar, Tooltip, Typography, useMediaQuery, useTheme} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {HamburgerButton} from "../../components/HamburgerButton";
import {ProjectSwitcher} from "./ProjectSwitcher";
import {HeaderActions} from "./HeaderActions";

// Workspace / project switcher and the project actions. The language is picked on the pages that use one
// (SubProjectSelect). role: the current user's role in the project (shown in the avatar menu)
export const RegistryProjectHeader = ({project, role, onOpenMenu}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <AppBar position="static" sx={{
      bgcolor: "#fff",
      boxShadow: 0,
      zIndex: 100,
      borderBottom: 1,
      borderColor: "divider",
      minHeight: "48px !important",
    }}>
      <Toolbar sx={{px: "8px !important", py: "0 !important", minHeight: "48px !important", gap: 1}}>
        <Stack direction={"row"} gap={0.5} alignItems={"center"} sx={{minWidth: 0, flex: 1}}>
          {isMobile && (
            <HamburgerButton onClick={onOpenMenu} sx={{mr: 0.25}}/>
          )}
          <IconButton component={RouterLink} to={"/projects"} sx={{p: 0.5, borderRadius: 1.75}}>
            <img src={"/logo.svg"} alt={"logo"} width={isMobile ? 26 : 36}/>
          </IconButton>
          {/* Workspace / Project: the workspace goes back to every project, the project name switches project */}
          <Stack direction={"row"} alignItems={"center"} gap={0.25} sx={{minWidth: 0, ml: 0.5}}>
            {!isMobile && (
              <>
                <Tooltip title={"Go back to all projects"}>
                  <Typography
                    component={RouterLink}
                    to={"/projects"}
                    sx={{
                      px: 0.75, py: 0.5, borderRadius: "8px", fontSize: 12, fontWeight: 500, color: "#8A8AA0",
                      textDecoration: "none", whiteSpace: "nowrap",
                      "&:hover": {bgcolor: "#F4F4FA", color: "#23264D"},
                    }}
                  >
                    {project?.organizationName || "Workspace"}
                  </Typography>
                </Tooltip>
                <Typography sx={{fontSize: 14, color: "#C9CAD8", mx: 0.25}}>/</Typography>
              </>
            )}
            <ProjectSwitcher project={project}/>
          </Stack>
        </Stack>

        <HeaderActions role={role} compact={isMobile}/>
      </Toolbar>
    </AppBar>
  );
};
